import {
  Component,
  OnInit,
  Input,
  EventEmitter,
  HostBinding,
  Output,
} from '@angular/core'

@Component({
  selector: 'custom-context-menu',
  templateUrl: './custom-context-menu.component.html',
  styleUrl: './custom-context-menu.component.scss',
  providers: [],
  standalone: false,
})
export class CustomContextMenuComponent implements OnInit {
  @Input() left = 0
  @Input() top = 0
  @Input() visible = false
  @Output() openInNewTab = new EventEmitter()

  @HostBinding('style.left.px') get hostLeft() {
    return this.left // Bind left property
  }

  @HostBinding('style.top.px') get hostTop() {
    return this.top // Bind top property
  }

  @HostBinding('style.display') get hostDisplay() {
    return this.visible ? 'block' : 'none' // Show/hide based on visibility
  }

  ngOnInit(): void {
    // throw new Error('Method not implemented.');
  }

  disableMenu() {}
}
